export default "__VITE_ASSET__C32YnNnW__"